var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v(" The balance between speed and accuracy in solution creation and switching. ")]),_c('div',{staticClass:"bar-chart-container"},[_c('BarChart',{attrs:{"chart-data":_vm.chartData,"options":_vm.chartOptions}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }